// import of a statemanager store. Adjust to meet component requirements.
import deepClone from 'foundation/js/deepClone'
import { useMenuStore } from 'stores/menu.store'
import { useMainStore } from 'stores/main.store'
import { computed, onMounted } from 'vue'
import TabNavigation from 'foundation/js/utils/tabNavigation'
import getLabelFromStore from 'foundation/js/getLabelFromStore'

export default {
    name: "OverlayPrompt",
    props:{
        closeTheModal:{
            type:Function,
            required: true
        },
        overlayContent:{
            type: String,
            required: false
        },
        dialogElement:{
            type: Element,
            required: true
        }
    },
    setup(props){

        const store = useMainStore()
        const menuStore = useMenuStore()

        // general overlay 
        const useFixedTemplate = computed(()=>!props.overlayContent.content.htmlString)
        const htmlString = computed(()=>props.overlayContent.content.htmlString ?? 'no content')
        const titleText = computed(()=>props.overlayContent.titleText) 

        // level overlay
        const isActiveLevel = computed( () => menuStore.activeMenu === 'changeRegion')

        const closeMenu = () => {
            menuStore.closeMenu()

            setTimeout(() => {
                const mobileOverlayRegion = document.querySelector('.be-js--mobile-region-overlay-button')
                mobileOverlayRegion?.focus()
            }, 50)
        }

        const getLabel = (labelKey) => getLabelFromStore({ labelKey: labelKey, collectionName: "MenuPrimary" })

        // menu overlay
        const handleMenuItem = function(menuItem) {
            menuStore.setActiveMenu(menuItem)

            setTimeout(() => {
                const mobileOverlayRegion = document.querySelector('.be-region-overlay-mobile')
                const firstInteractiveElement = mobileOverlayRegion?.querySelector('.be-js--mobile-menu-item')
                firstInteractiveElement?.focus()
            }, 50)
        }

        const primaryMenuMobileData = computed(()=>{
            const data = deepClone(store.primaryMenuMobileData)
            delete data.actionsDisplayNames

            // we need to use the same order as in desktop version
            const dataAsArray = []
            for(let group in data){
                dataAsArray[data[group].order] = data[group]
            }

            return dataAsArray
        })
        const menuActionsDisplayNames = computed(()=>store.primaryMenuMobileData.actionsDisplayNames)
        const secondaryMenuMobileData = computed(()=>store.secondaryMenuMobileData)
        const regionMenuMobileData = computed( () => store.regionMenuData.sort((a, b) => a.order - b.order))
        const ctaButtonData = computed(()=>store.primaryMenuMobileData.ctaButton)

        const menuLinkType = function(link){
            if(link.toplevel === true) return 'be-menu-primary__mega-menu-list-item--top'
            if(link.type === 'featured') return 'be-menu-primary__mega-menu-list-item--featured be-font-link be-font-link-3'
        }

        onMounted(()=>{
            // we need to avoid showing the mobile menu on desktop sizes
            window.addEventListener('resize',()=>{
                const breakpointTablet = store.breakpoints.tablet
                if(window.innerWidth >= breakpointTablet) {
                    props.dialogElement.close()
                    store.clearOverlay()
                }
            })
        })

        const tabTrap = function(e) {
            const tabProps = {
                parentContainer: props.dialogElement,
                targetClassName: 'be-js--mobile-menu-item',
                key: e.key,
            }
            const tabTrap = new TabNavigation(tabProps)

            if (e.key === 'Tab') {
                e.preventDefault()
                if (e.shiftKey) {
                    tabTrap.tabTrapPrev()
                } else {
                    tabTrap.tabTrapNext()
                }   
            }
        }

        return {
            isActiveLevel,
            ctaButtonData,
            handleMenuItem,
            closeMenu,
            getLabel,
            htmlString,
            menuLinkType,
            menuActionsDisplayNames,
            primaryMenuMobileData,
            secondaryMenuMobileData,
            regionMenuMobileData,
            titleText,
            useFixedTemplate,
            tabTrap
        }
    }
}